'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
require('react');
require('../../components/StyledMarkup/index.js');
require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
var index$1 = require('../../components/Icon/index.js');
require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
require('../../components/ItemCard/index.js');
require('../../components/SelectItem/index.js');
var index = require('../../components/SelectList/index.js');
require('../../components/ErrorBanner/index.js');
require('../../components/Footer/index.js');
require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@babel/runtime/helpers/extends');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/ItemCardSkeleton.js');
require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledConfirmationHeader = styled__default["default"].header.withConfig({
  componentId: "sc-p3prrt-0"
})(["text-align:left;"]);
const StyledBtnContainer = styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-1"
})(["margin:1.5rem 0;"]);
const StyledImgContainer = styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-2"
})(["width:50%;max-width:200px;"]);
const AlternateEmailForm = styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-3"
})(["max-width:400px;margin:15px 0;display:flex;gap:20px;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-4"
})(["padding-top:24px;display:flex;flex-direction:column;gap:16px;align-items:start;"]);
styled__default["default"](index.SelectList).withConfig({
  componentId: "sc-p3prrt-5"
})(["width:auto;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-6"
})(["display:grid;grid-template:'Icon Description';grid-template-columns:auto 1fr;grid-gap:16px;align-items:center;"]);
styled__default["default"](index$1["default"]).withConfig({
  componentId: "sc-p3prrt-7"
})(["grid-area:Icon;width:32px;height:32px;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-8"
})(["grid-area:Description;"]);
styled__default["default"].div.withConfig({
  componentId: "sc-p3prrt-9"
})(["margin-bottom:8px;"]);

exports.AlternateEmailForm = AlternateEmailForm;
exports.StyledBtnContainer = StyledBtnContainer;
exports.StyledConfirmationHeader = StyledConfirmationHeader;
exports.StyledImgContainer = StyledImgContainer;
